import { Divider, Group, Stack, Switch, Text } from "@mantine/core";
import React from "react";
import { dividerWeight, labelWeight } from "../reportBoardConstants";

const GeoteknikSettings: React.FC<{
  veiledningsTekst: boolean;
  eksempelTekst: boolean;
  updateVeiledningsTekst: (value: boolean) => void;
  updateEksempelTekst: (value: boolean) => void;
}> = ({ veiledningsTekst, eksempelTekst, updateVeiledningsTekst, updateEksempelTekst }) => {
  return (
    <Stack gap="xs">
      <Divider
        label={
          <Text fz="lg" fw={dividerWeight}>
            Innstillinger
          </Text>
        }
        labelPosition="center"
        mb="xs"
      />

      <Group grow>
        <Text fw={labelWeight}>Veiledningstekst:</Text>
        <Switch checked={veiledningsTekst} onChange={(e) => updateVeiledningsTekst(e.currentTarget.checked)} />
      </Group>

      <Group grow>
        <Text fw={labelWeight}>Eksempeltekst:</Text>
        <Switch checked={eksempelTekst} onChange={(e) => updateEksempelTekst(e.currentTarget.checked)} />
      </Group>
    </Stack>
  );
};

export default GeoteknikSettings;
